export default {
    // quoteSummary.js
    'Colors and materials are for reference only. Actual selection options may vary. See your Freightliner Trucks dealership for complete details.' : 'Colors and materials are for reference only. Actual selection options may vary. See your Freightliner Trucks dealership for complete details.',
    // itemCard.js
    'Details +' : 'Details +',
    'None' : 'None',
    'Most Aerodynamic' : 'Most Aerodynamic',
    'Recommended' : 'Recommended',
    // configuratorMain.js
    'For best results, align your device vertically.' : 'For best results, align your device vertically.',
    // requestQuote.js
    'Request A Quote' : 'Request A Quote',
    'Considering a new Freightliner truck purchase and ready for more details? You&#39;re in the right place. Request a quote here. All fields marked with an * are required.' : 'Considering a new Freightliner truck purchase and ready for more details? You&#39;re in the right place. Request a quote here. All fields marked with an * are required.',
    'Thank You' : 'Thank You',
    'Your quote has been submitted and you will be contacted soon.' : 'Your quote has been submitted and you will be contacted soon.',
    'Your quote has been submitted. Please reach out to your selected dealer below with any questions.' : 'Your quote has been submitted. Please reach out to your selected dealer below with any questions.',
    'Please enter a more specific mailing address.' : 'Please enter a more specific mailing address.',
    'Please make sure this address is correct:' : 'Please make sure this address is correct:',
    'Enter your international address' : 'Enter your international address',
    'Apartment / Suite (optional)' : 'Apartment / Suite (optional)',
    'My Dealer' : 'My Dealer',
    'Search in' : 'Search in',
    'US & Canada' : 'US & Canada',
    'Global Dealer Locations' : 'Global Dealer Locations',
    'City or Address' : 'City or Address',
    'Dealers' : 'Dealers',
    'Miles Away' : 'Miles Away',
    'Checking for dealers near you...' : 'Checking for dealers near you...',
    'Required' : 'Required',
    'REQUEST QUOTE' : 'REQUEST QUOTE',
    'Loading' : 'Loading',
    'Hang on while we update your truck...' : 'Hang on while we update your truck...',
    'SUBMIT' : 'SUBMIT',
    'First Name' : 'First Name',
    'Last Name' : 'Last Name',
    'Email' : 'Email',
    'Company or Business Name': 'Company or Business Name',
    'Company Website': 'Company Website',
    'Business Postal Code' : 'Business Postal Code',
    'Business Country': 'Business Country',
    'Business Postal Code and Country' : 'Business Postal Code and Country',
    'Mailing Address' : 'Mailing Address',
    'Phone' : 'Phone',
    'How will you use your truck?' : 'How will you use your truck?',
    'Temperature Controlled / Reefer' : 'Temperature Controlled / Reefer',
    'Regional Distribution' : 'Regional Distribution',
    'Pick-up & Delivery' : 'Pick-up & Delivery',
    'TL / LTL' : 'TL / LTL',
    'When do you plan to purchase?' : 'When do you plan to purchase?',
    'Select an Engine' : 'Select an Engine',
    'Select My Dealer' : 'Select My Dealer',
    'Comments' : 'Comments',
    'Send me promotions, product news, etc.' : 'Send me promotions, product news, etc.',
    // dialogOverlay.js
    'Back to Cab Types' : 'Back to Cab Types',
    'Click and Drag to Rotate Truck' : 'Click and Drag to Rotate Truck',
    'Cancel' : 'Cancel',
    'Next' : 'Next',
    'Select' : 'Select',
    'Get a Quote' : 'Get a Quote',
    'Edit' : 'Edit',
    'Share' : 'Share',
    'Updated images coming soon' : 'Updated images coming soon',
    // optionsTray.js
    'Additional colors available when you visit your Freightliner Dealer. <br><br> Colors are for reference only. Actual selection options may vary.' : 'Additional colors available when you visit your Freightliner Dealer. <br><br> Colors are for reference only. Actual selection options may vary.',
    'Exterior' : 'Exterior',
    'Interior' : 'Interior',
    'Powertrain & Safety' : 'Powertrain & Safety',
    // cabTypes.js
    'New Cascadia Configurator' : 'New Cascadia Configurator',
    'Choose a cab below to begin building your truck.' : 'Choose a cab below to begin building your truck.',
    'Day Cab' : 'Day Cab',
    'Sleeper Cab' : 'Sleeper Cab',
    '116" BBC Day Cab' : '116" BBC Day Cab',
    '126" BBC Day Cab' : '126" BBC Day Cab',
    '116" BBC 48" XT' : '116" BBC 48" XT',
    '116" BBC 60" XT' : '116" BBC 60" XT',
    '116" BBC 60" RR' : '116" BBC 60" RR',
    '116" BBC 72" XT' : '116" BBC 72" XT',
    '116" BBC 72" RR' : '116" BBC 72" RR',
    '126" BBC 48" XT' : '126" BBC 48" XT',
    '126" BBC 60" XT' : '126" BBC 60" XT',
    '126" BBC 60" RR' : '126" BBC 60" RR',
    '126" BBC 72" XT' : '126" BBC 72" XT',
    '126" BBC 72" RR' : '126" BBC 72" RR',
    // modalDialog.js
    'Step' : 'Step',
    'of' : 'of',
    'Prev' : 'Prev',
    'Included': 'Included',
    'Business Postal Code': 'Business Postal Code',
	'materials-option-disclaimer': '<span></span>'
}